<template>
    <div>
        <div class="crm-button-bar primary">
            <v-tooltip bottom >
                <template v-slot:activator="{ on, attrs }">
                    <a
                        @click = "onCancel"
                        v-bind = "attrs"
                        v-on   = "on"
                    >
                        <v-icon color="white" left>fa fa-times</v-icon>
                    </a>
                </template>
                <span>{{ $t('crm.menu.cancel') }}</span>
            </v-tooltip>

            <v-spacer />

            <v-tooltip bottom >
                <template v-slot:activator="{ on, attrs }">
                    <a
                        @click = "onSave"
                        v-bind = "attrs"
                        v-on   = "on"
                    >
                        <v-icon color="white" >fa fa-save</v-icon>
                    </a>
                </template>
                <span>{{ $t('crm.menu.save') }}</span>
            </v-tooltip>
        </div>

        <crm-entry-edit
            :entry    = "entry"
            :incident = "incident"
            class     = "mb-1"
            ref       = "editor"
            @saved    = "onSaved"
        />
    </div>
</template>

<script>

import CrmEntryEdit from "@/modules/crm/components/main/CrmEntryEdit";

export default {
    name: "CrmEntryTabItem",

    components: {
        CrmEntryEdit,
    },

    props: {
        incident: {
            required: true,
            type: Object,
        },

        entry: {
            required: true,
            type    : Object,
        }
    },

    methods: {
        onCancel () {
            this.$emit("cancel");
        },

        onSaved () {
            this.$emit("saved");
        },

        onSave () {
            this.$refs.editor.onSave();
        },
    }
}
</script>

<style scoped>

.crm-button-bar {
    display: flex;
    justify-content: space-between;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 3px;
}

</style>